import "./styles/main.scss";

import { registerSW } from "virtual:pwa-register";

import { HtmlActuator } from "./adapters/html-actuator";
import { KeyboardInputManager } from "./adapters/keyboard-input-manager";
import { LocalStorageManager } from "./adapters/local-storage-manager";
import { initSentry } from "./analytics/sentry";
import { GameController } from "./game-controller";
import { shouldDisplayAppendix } from "./i18n/language-banner";
import { createThemeToggle, initTheme } from "./theme";
import { showUpdatePrompt } from "./update-prompt";

initSentry();

// Register the PWA service worker. A new version installs in the background and
// waits; instead of reloading the open app automatically, we ask the player and
// only update (skip waiting + reload) once they click Reload.
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    showUpdatePrompt(() => {
      void updateSW(true);
    });
  },
});

const storage = new LocalStorageManager();
// Apply the saved/system theme and keep following the OS while the pref is unset.
initTheme(storage);

const input = new KeyboardInputManager();
const actuator = new HtmlActuator(() => shouldDisplayAppendix(storage));

new GameController(input, actuator, storage);

// Small version/build label in the corner — handy for telling which build is
// live (e.g. after a deploy or the service-worker migration). The value is
// injected at build time from package.json + the short git SHA.
const versionLabel = document.createElement("div");
versionLabel.className = "version-label";
versionLabel.textContent = `v${__APP_VERSION__}`;
versionLabel.setAttribute("aria-hidden", "true");
document.body.appendChild(versionLabel);

// Inject the light/dark toggle next to "New Game".
createThemeToggle(storage);

// When embedded in an iframe, open the title link in a new tab (ported from the original).
try {
  if (window.self !== window.top) {
    document.querySelector(".title-link")?.setAttribute("target", "_blank");
  }
} catch {
  document.querySelector(".title-link")?.setAttribute("target", "_blank");
}
